module.exports = __webpack_public_path__ + "static/media/icon-plus-white.663b763a.svg";